export const TOKEN = 'token'

// token 时间戳
export const TIME_STAMP = 'timeStamp'

// 超时时长(毫秒) 两小时
export const TOKEN_TIMEOUT_VALUE = 24 * 7 * 3600 * 1000

// localfs
export const LOCALFS_ROOT = '/localfs/'
export const TAGS_VIEW = 'tagsViewList'
export const LANG = 'language'
// 预警级别
export const warningLevel = [
    { label: '严重错误', value: '1' },
    { label: '错误', value: '2' },
    { label: '告警', value: '3' }
]
// 锁定状态
export const lockOptions = [
    { label: '无任何锁定 ', value: 0 },
    { label: '开关锁定 ', value: 1 },
    { label: '温度锁定 ', value: 2 },
    { label: '开关、温度锁定 ', value: 3 },
    { label: '模式锁定 ', value: 4 },
    { label: '模式、开关锁定 ', value: 5 },
    { label: '模式、温度锁定 ', value: 6 },
    { label: '模式、温度、开关锁定 ', value: 7 },
    { label: '风速锁定 ', value: 8 },
    { label: '风速、开关锁定 ', value: 9 },
    { label: '风速、温度锁定 ', value: 10 },
    { label: '风速、温度、开关锁定 ', value: 11 },
    { label: '风速、模式锁定 ', value: 12 },
    { label: '风速、模式、开关锁定 ', value: 13 },
    { label: '风速、模式、温度锁定 ', value: 14 },
    { label: '风速、模式、温度、开关锁定 ', value: 15 }
]
// 风速
export const speed = [
    { label: '自动', value: 0 },
    { label: '低速', value: 1 },
    { label: '中速', value: 2 },
    { label: '高速', value: 3 }
]
// 运行模式
export const run_mode = [
    { label: '自动', value: 0 },
    { label: '制冷', value: 1 },
    { label: '制热', value: 2 },
    { label: '送风', value: 3 }
]
export const room_card_status = [
    { label: '不使能', value: 0 },
    { label: '常开', value: 1 },
    { label: '常闭', value: 2 }
]
